import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

const Blockquote = styled.blockquote`
  transition: ${p => p.theme.colorModeTransition};
  margin: 48px auto 64px;
  color: ${p => p.theme.colors.primary};
  font-family: ${p => p.theme.fonts.title};

  & > p {
    font-family: ${p => p.theme.fonts.title};
    width: 100%;
    max-width: 1112px;
    padding: 0 40px;
    margin: 0 auto;
    font-size: 56px;
    line-height: 1.32;
    letter-spacing: -2px;
    font-weight: ${p => p.theme.fontsWeight.bold};

    ${mediaqueries.tablet`
      font-size: 40px;
      padding: 0 24px;
    `};
  }

  strong {
    font-family: ${p => p.theme.fonts.titleEm};
    text-transform: uppercase;
    font-style: italic;
    font-weight: ${p => p.theme.fontsWeight.regular};
  }

  em {
    font-family: ${p => p.theme.fonts.titleEm};
    font-style: italic;
    font-weight: ${p => p.theme.fontsWeight.regular};
  }

  cite {
    display: block;
    font-size: 24px;
    margin-top: 16px;
    color: ${p => p.theme.colors.secondary};
    font-style: normal;
    padding-left: 40px;
    
    ${mediaqueries.tablet`
      font-size: 22px;
      padding: 0 24px;
    `};
  }
`;

export default Blockquote;
